module.exports = __webpack_public_path__ + "static/media/success.1674a9c7.svg";